"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = Label;
var _polished = require("polished");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Field = require("../Field");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//
// Styled components
// -------------------------------------------------------------------------------------------------
const Base = _styledComponents.default.label`
  color: ${p => p.theme.colors.independence};
  font-family: ${p => p.theme.fonts.robotoMono};
  font-size: ${(0, _polished.rem)(12)};
  font-weight: 500;
  letter-spacing: ${(0, _polished.rem)(0.43)};
  opacity: 0.75;
  padding-left: ${(0, _polished.rem)(4)};
  text-transform: uppercase;
`;

//
// Main component
// -------------------------------------------------------------------------------------------------
function Label({
  children,
  forId
}) {
  const fieldId = (0, _Field.useField)();
  return /*#__PURE__*/_react.default.createElement(Base, {
    htmlFor: forId || fieldId
  }, children);
}